<div class="power-game" [class.is-immersive]="isFullscreen" *ngIf="round">

  <!-- Prompt: base^exp = ? with its expansion -->
  <div class="prompt-bar">
    <span class="prompt-text">{{ currLang === 'ar' ? 'كم يساوي' : 'What is' }}</span>
    <span class="power">{{ round.base }}<sup>{{ round.exp }}</sup></span>
    <span class="prompt-text">?</span>
    <span class="expand">= {{ expansion }}</span>
  </div>

  <!-- Whose turn -->
  <div class="turn-chip" *ngIf="student">
    <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
    <div class="turn-text">
      <span class="turn-name">{{ studentName }}</span>
      <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
    </div>
  </div>

  <!-- Round progress -->
  <div class="round-dots">
    <span class="dot" *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]" [class.current]="i === currentRound"></span>
  </div>

  <!-- Interactive stage -->
  <div class="stage-wrap">
    <app-power-burst-stage
      [round]="round"
      [roundKey]="currentRound"
      [interactive]="!resolving"
      [currLang]="currLang"
      (solved)="onSolved()"
      (missed)="onMissed()">
    </app-power-burst-stage>
  </div>

  <!-- Controls -->
  <div class="controls">
    <span class="hint">{{ currLang === 'ar' ? 'اختر القيمة الصحيحة لتفجّر القوة!' : 'Tap the right value to blast the power!' }}</span>
    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
    </button>
  </div>

  <!-- Success -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <span class="success-icon" aria-hidden="true">💥</span>
      <span class="success-eq">{{ round.base }}<sup>{{ round.exp }}</sup> = {{ round.value }}</span>
      <span class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</span>
    </div>
  </div>

  <app-fullscreen-toggle [isFullscreen]="isFullscreen" [currLang]="currLang" (toggle)="toggleFullscreen()"></app-fullscreen-toggle>
</div>
